module.exports = __webpack_public_path__ + "img/South Carolina.6f45c31d.png";